import {httpGet} from './http.service';
import {UserConfig} from '../incase-domain/user';

export const fetchUserConfig = (userId: string): Promise<UserConfig> => {
    if (!userId) return Promise.resolve({});

    return httpGet(`editor/userConfig/${userId}`);
};
